import { Box, Spinner, Text } from "@chakra-ui/react";

function Loading({ isLoading }: { isLoading?: boolean }) {
  if (!isLoading) return null;
  return (
    <Box textAlign="center" py={4}>
      <Spinner
        color="blue.500"
        size={"lg"}
        borderWidth="4px"
        css={{ "--spinner-track-color": "colors.gray.200" }}
      />
      <Box>
        <Text>Loading...</Text>
      </Box>
    </Box>
  );
}

export default Loading;
